import * as React from 'react';
import './PVABadge.css';

interface PVABadgeProps {
    style: string;
    badge: string;
}

export class PVABadge extends React.Component<PVABadgeProps, {}> {
    constructor(props: PVABadgeProps) {
        super(props);
    }

    render() {
        return (
            <div className={`pva-badge ${this.props.style}`}>
                <div className="pva-badge-inner">
                    <div className="bg"/>
                    <div className="text">{this.props.badge}</div>
                </div>
            </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/reports/blocks/PVABadge.tsx